import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class ProcessingMixin extends Vue {
  private processing = false

  public startProcess(): void {
    this.processing = true
  }

  public endProcess(): void {
    this.processing = false
  }

  public isProcess(): boolean {
    return this.processing
  }
}
